var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-input"},[_c('label',{staticClass:"label",attrs:{"for":_vm.label}},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('input',{staticClass:"input",attrs:{"type":_vm.type,"id":_vm.label,"aria-label":_vm.ariaLabel},on:{"input":function($event){return _vm.input($event.target.value)}}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a4781336","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppInput/AppInput.vue
// module id = null
// module chunks = 